import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material';
import React from 'react';
import { Box } from '../Box';
const StyledBox = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    margin: '0 auto',
    maxWidth: '1280px',
    padding: '1.25rem'
});
export const FooterContainer = React.forwardRef((props, ref) => (_jsx(StyledBox, { ref: ref, ...props })));
FooterContainer.displayName = 'FooterContainer';
